const $ = require('jquery');

const $navbar = $('nav.navbar'),
    $nav = $navbar.find('.menu').clone(),
    $offcanvas = $('<nav id="offcanvas-menu"></nav>'),
    $navbarLogo = $navbar.find('img').clone(),
    $socialLinks = $('footer .social-links').clone(),
    $logo = $('<div class="logo" />');

$logo.append($navbarLogo);
$logo.appendTo($offcanvas);
$socialLinks.appendTo($offcanvas);
$offcanvas.append('<hr>')
$nav.appendTo($offcanvas);

$offcanvas.insertAfter($navbar);

$navbar.find('.navbar-toggler').click(e => {
    $('body').toggleClass('offcanvas-open');
});

$(document).click(e => {

    if (!$(e.target).hasClass('navbar-toggler') && !$(e.target).parent().hasClass('navbar-toggler') && $(e.target).closest('#offcanvas-menu').length == 0) {
        $("body").removeClass('offcanvas-open');
    }

});
